import React from "react";
import styles from "./StoryOfAtworkSection.module.scss";
import cardImage from "../../../assets/images/card-image.jpg";

const StoryOfAtworkSection = () => {
  return (
    <div className={styles.storyOfAtworkSectionContainer}>
      <h1 className={styles.mainTitle}>the story of an artwork</h1>
      <div className={styles.list}>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={cardImage} alt="The Title Of The Work" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Work">
              The Title Of The Work
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={cardImage} alt="The Title Of The Work" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Work">
              The Title Of The Work
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={cardImage} alt="The Title Of The Work" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Work">
              The Title Of The Work
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={cardImage} alt="The Title Of The Work" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Work">
              The Title Of The Work
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.viewAllCentered}>View All</div>
    </div>
  );
};

export default StoryOfAtworkSection;
